import { v4 } from 'uuid';

/*
 * Given a file and empty created image, return an Image object for the ImageUploader
 * @sig convertToImage :: (File, Image) -> Image
 */
const convertToImage = (file, image) => ({
    tmpId: v4(), // React needs a unique ID in order to sort
    file,
    caption: file.name,
    dimensions: { height: image.height, width: image.width },
    size: file.size,
    type: file.type,
    uri: image.src,
    dateUploaded: new Date(Date.now()),
});

export { convertToImage };
